"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplierDocumentAttachment = void 0;
const typeorm_1 = require("typeorm");
const SupplierAttachment_1 = require("./SupplierAttachment");
const DocumentType_1 = require("./DocumentType");
const DocumentTypeState_1 = require("./DocumentTypeState");
let SupplierDocumentAttachment = class SupplierDocumentAttachment extends SupplierAttachment_1.SupplierAttachment {
    constructor(init) {
        super();
        if (init) {
            Object.assign(this, init);
        }
    }
};
exports.SupplierDocumentAttachment = SupplierDocumentAttachment;
__decorate([
    (0, typeorm_1.ManyToOne)(() => DocumentType_1.DocumentType),
    __metadata("design:type", DocumentType_1.DocumentType)
], SupplierDocumentAttachment.prototype, "documentType", void 0);
__decorate([
    (0, typeorm_1.RelationId)((sda) => sda.documentType),
    __metadata("design:type", String)
], SupplierDocumentAttachment.prototype, "documentTypeId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => DocumentTypeState_1.DocumentTypeState),
    __metadata("design:type", DocumentTypeState_1.DocumentTypeState)
], SupplierDocumentAttachment.prototype, "documentState", void 0);
__decorate([
    (0, typeorm_1.RelationId)((sdc) => sdc.documentState),
    __metadata("design:type", String)
], SupplierDocumentAttachment.prototype, "documentStateId", void 0);
exports.SupplierDocumentAttachment = SupplierDocumentAttachment = __decorate([
    (0, typeorm_1.ChildEntity)('document'),
    __metadata("design:paramtypes", [Object])
], SupplierDocumentAttachment);
